module.exports = __webpack_public_path__ + "img/img-eat-09.44d89b97.png";